"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const clientConfigFromServer = window
    .clientConfig;
exports.config = Object.assign(Object.assign({}, clientConfigFromServer), { oidcRedirectUri: getRedirectUri(clientConfigFromServer.oidcAuthority), getBackendFullUrl: relativeUrl => {
        return `${clientConfigFromServer.genesysBackend.replace(/\/$/, "")}/${relativeUrl.replace(/^\//, "")}`;
    }, environment: getEnvironment(clientConfigFromServer), graphqlEndpoint: `${clientConfigFromServer.genesysBackend.replace(/\/$/, "")}/graphql`, authorization: { type: "bearer", accessToken: "" } });
function getEnvironment(clientConfigFromServer) {
    if (window.location.hostname.toUpperCase() === "LOCALHOST") {
        return "localhost";
    }
    return clientConfigFromServer.environment;
}
function getRedirectUri(oidcAuthority) {
    if (oidcAuthority.indexOf("keycloak") > -1) {
        return window.location.origin.replace(/\/$/, "") + "/signinoidc";
    }
    return window.location.origin;
}
//# sourceMappingURL=index.js.map